import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";
import { useHistory } from "react-router-dom";
export const PurchaseOrder = () => {
  const history = useHistory();
  const viewAllPurchaseOrders = () => {
    return fetch(`${API}/purchase-orders`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
       userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => {
        return { err: err.message };
      });
  };

  const viewPurchaseOrder = (id) => {
    return fetch(`${API}/purchase-orders/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => {
        return { err: err.message };
      });
  };

  const addPurchaseOrder = (purchaseOrder) => {
    return fetch(`${API}/purchase-orders`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(purchaseOrder),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => {
        return { err: err.message };
      });
  };

  const updatePurchaseOrder = (id, purchaseOrder) => {
    return fetch(`${API}/purchase-orders/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(purchaseOrder),
    })
      .then((response) => {
       userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => {
        return { err: err.message };
      });
  };

  const deletePurchaseOrder = (id) => {
    return fetch(`${API}/purchase-orders/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => {
        return { err: err.message };
      });
  };

  return {
    viewAllPurchaseOrders,
    viewPurchaseOrder,
    addPurchaseOrder,
    updatePurchaseOrder,
    deletePurchaseOrder,
  };
};
